import Nav from "../component/Navbar/Nav";
import Footer from "../component/Footer/Footer";
import { Outlet } from "react-router-dom";
import ScrollToTop from "../component/common/ScrollToTop";
import ScrollToTopButton from "../component/common/ScrollToTopButton";

const MainLayout = () => {
  return (
    <>
      <ScrollToTop />
      <ScrollToTopButton />
      <Nav />
      <Outlet />   {/* 🔥 THIS LINE IS MUST */}
      <Footer />
    </>
  );
};

export default MainLayout;